import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import ButtonCTAOnboarding from './components/ButtonCTAOnboarding';
import { CardsAssistant } from './components/CardsAssistant';
import OnboardingInput from './components/OnboardingInput';

const assistantGoals = [
  {
    title: 'Warm outreach to leads',
    description: `Send a warm, personalized message to see if they're still in the market.`,
  },
  {
    title: 'Qualify leads',
    description: `Identify the most promising leads, and skip the ones that aren't a fit.`,
  },
  {
    title: 'Keep contacts updated',
    description: `Update lead details automatically when they share new information.`,
  },
];
export const CompleteYourProfile = () => {
  const [fullName, setFullName] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          // backgroundColor: theme.palette.background.default,
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          position: 'relative',
        }}
      >
        <Box sx={{ position: 'absolute', top: 32, left: 32, zIndex: 2 }}>
          <img
            src="/icon/artwork.svg"
            alt="Oppy Logo"
            style={{ width: 80, height: 'auto' }}
          />
        </Box>
        <Box
          sx={{ width: '100%', maxWidth: 420, mx: 'auto', textAlign: 'center' }}
        >
          <Typography color="#A1A1AA" fontSize={16} mb={1} fontWeight={400}>
            3 of 4
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            fontWeight={700}
            fontSize={28}
            mb={1}
          >
            Complete your profile
          </Typography>
          <Typography
            color="#D1D1D6"
            fontSize={16}
            mb={4}
            width={'100%'}
            textAlign={'center'}
          >
            Add your name and a secure password.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
            <OnboardingInput
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Enter your full name"
              margin="normal"
              label="Full name"
            />

            <OnboardingInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              type="password"
              margin="normal"
              label="Password"
            />

            <OnboardingInput
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your password"
              type="password"
              margin="normal"
              label="Confirm password"
            />
          </Box>
          <ButtonCTAOnboarding
            variant="contained"
            label="Continue"
            onClick={() => {}}
          >
            Continue
          </ButtonCTAOnboarding>
          <Button
            startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 18 }} />}
            sx={{
              color: '#4949C8',
              fontWeight: 400,
              fontSize: 16,
              textTransform: 'none',
              mt: 2,
              alignSelf: 'center',
              background: 'none',
              boxShadow: 'none',
              fontFamily: 'Space Grotesk',
              '&:hover': { background: 'none', textDecoration: 'underline' },
            }}
            variant="text"
          >
            Back
          </Button>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CardsAssistant
          name={fullName}
          email={password}
          goals={assistantGoals}
        />
      </Grid>
    </Grid>
  );
};
